import React from 'react';

import {
  Grid,
  Button,
} from '@material-ui/core';
import NextIcon from '@material-ui/icons/ChevronRight';
import PrevIcon from '@material-ui/icons/ChevronLeft';

import InputField from '../../common/components/inputField';
import * as asyncSelectData from '../../common/asyncSelectData';

import classes from '../../css/getCSS';


const contactInfoForm = (props) => {
  let buttons = (
    <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
      Update
    </Button>
  );

  if (!props.editMode) {
    buttons = (
      <React.Fragment>
        <Button onClick={() => props.redirectToStep(props.prevStep)} variant="contained" color="primary" size="large" className={classes.Button} style={{ marginRight: '10px' }}>
          <PrevIcon />
          Back
        </Button>
        <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
          Next
          <NextIcon />
        </Button>
      </React.Fragment>
    );
  }

  let blockquote = null;

  if (!props.editMode) {
    blockquote = (
      <React.Fragment>
        <blockquote className={classes.profileFormQuote}>
        Your address and contact details.
        </blockquote>
        <br /><br />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {blockquote}
      <Grid container spacing={24}>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="self_address"
            config={props.inputs.self_address}
            changed={event => props.inputChangedHandler(event, 'self_address')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="self_city"
            config={props.inputs.self_city}
            changed={event => props.inputChangedHandler(event, 'self_city')}
            loadOptions={asyncSelectData.getCityOptions}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="self_contact_no"
            config={props.inputs.self_contact_no}
            changed={event => props.inputChangedHandler(event, 'self_contact_no')}
          />
        </Grid>
      </Grid>
      <hr className={classes.formHR} /><br />
      <Grid container spacing={24}>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="family_address"
            config={props.inputs.family_address}
            changed={event => props.inputChangedHandler(event, 'family_address')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="family_city"
            config={props.inputs.family_city}
            changed={event => props.inputChangedHandler(event, 'family_city')}
            loadOptions={asyncSelectData.getCityOptions}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="location"
            config={props.inputs.location}
            changed={event => props.inputChangedHandler(event, 'location')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="residence_type"
            config={props.inputs.residence_type}
            changed={event => props.inputChangedHandler(event, 'residence_type')}
            loadOptions={() => asyncSelectData.getOptionConstants('residence_type')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="rooms_count"
            config={props.inputs.rooms_count}
            changed={event => props.inputChangedHandler(event, 'rooms_count')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="residence_area"
            config={props.inputs.residence_area}
            changed={event => props.inputChangedHandler(event, 'residence_area')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="residence_phone"
            config={props.inputs.residence_phone}
            changed={event => props.inputChangedHandler(event, 'residence_phone')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="father_contact"
            config={props.inputs.father_contact}
            changed={event => props.inputChangedHandler(event, 'father_contact')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="mother_contact"
            config={props.inputs.mother_contact}
            changed={event => props.inputChangedHandler(event, 'mother_contact')}
          />
        </Grid>
      </Grid>
      <br />
      {buttons}
    </React.Fragment>
  );
};

export default contactInfoForm;



// WEBPACK FOOTER //
// ./src/profile/components/ContactInfoForm.js